/** India timezone for admission UI (list + detail + exports). */
const TZ = "Asia/Kolkata";

export function formatAdmissionDateTimeIST(value) {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString("en-IN", {
        timeZone: TZ,
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });
}

export function formatAdmissionDateIST(value) {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("en-IN", { timeZone: TZ });
}

/** Matches `admission.route.js` status validation. */
export function admissionStatusLabel(status) {
    switch (status) {
        case "Paid":
            return "Paid";
        case "Deactive":
            return "Deactive";
        case "Active":
            return "Active";
        case "Failed":
            return "Failed";
        default:
            return status ? String(status) : "—";
    }
}

export function admissionStatusRowClass(status) {
    if (status === "Paid") return "Paid";
    if (status === "Deactive") return "Deactive";
    if (status === "Active") return "Active";
    if (status === "Failed") return "Failed";
    return "";
}
